import React from 'react';
import { RowButton, TableCard } from './styled';
import { TonePill } from '../../components';

export default function PermissionsMatrix({ roles, sections, onSelect }) {
  return (
    <TableCard aria-labelledby="perm-title">
      <header>
        <h2 id="perm-title">Permissions</h2>
        <span>default access by role · select a section for details</span>
      </header>
      <div className="scroll">
        <table
          role="table"
          style={{ '--grid': `minmax(160px, 2fr) repeat(${roles.length}, minmax(0, 1fr)) minmax(0, 1fr)` }}
        >
          <thead>
            <tr role="row">
              <th role="columnheader" scope="col">Section</th>
              {roles.map((r) => (
                <th key={r.key} role="columnheader" scope="col">
                  {r.label}
                </th>
              ))}
              <th role="columnheader" scope="col">Capabilities</th>
            </tr>
          </thead>
          <tbody>
            {sections.map((s) => (
              <tr key={s.group} role="row" onClick={() => onSelect(s.group)}>
                <td role="cell">
                  <RowButton type="button" aria-haspopup="dialog">
                    {s.group}
                  </RowButton>
                </td>
                {roles.map((r) => (
                  <td key={r.key} role="cell" data-label={r.label}>
                    <TonePill $tone={s.access[r.key].tone}>{s.access[r.key].label}</TonePill>
                  </td>
                ))}
                <td role="cell" data-label="Capabilities">
                  {s.items.length}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </TableCard>
  );
}
